export default __webpack_public_path__ + "static/media/Front_Plate_Detail.51bf49d4.png";